export const purchasesreturn = [
  {
    id: "1",
    img: "assets/img/products/stock-img-01.png",
    date: "2/27/2022",
    supplier: "Apex Computers",
    reference: "PT001",
    status: "Received",
    grandTotal: "550",
    paid: "120",
    due: "550",
    paymentStatus: "Paid",
  },
  {
    id: "2",
    img: "assets/img/products/stock-img-06.png",
    date: "1/15/2022",
    supplier: "Modern Automobile",
    reference: "PT002",
    status: "Pending",
    grandTotal: "550",
    paid: "120",
    due: "550",
    paymentStatus: "Overdue",
  },
  {
    id: "3",
    img: "assets/img/products/stock-img-02.png",
    date: "3/24/2022",
    supplier: "AIM Infotech",
    reference: "PT003",
    status: "Pending",
    grandTotal: "210",
    paid: "120",
    due: "210",
    paymentStatus: "Unpaid",
  },
  {
    id: "4",
    img: "assets/img/products/stock-img-03.png",
    date: "1/15/2022",
    supplier: "Best Power Tools",
    reference: "PT004",
    status: "Received",
    grandTotal: "210",
    paid: "120",
    due: "210",
    paymentStatus: "Paid",
  },
  {
    id: "5",
    img: "assets/img/products/stock-img-04.png",
    date: "1/15/2022",
    supplier: "AIM Infotech",
    reference: "PT005",
    status: "Pending",
    grandTotal: "210",
    paid: "120",
    due: "210",
    paymentStatus: "UnPaid",
  },
  {
    id: "6",
    img: "assets/img/products/stock-img-05.png",
    date: "3/24/2022",
    supplier: "Best Power Tools",
    reference: "PT006",
    status: "Received",
    grandTotal: "210",
    paid: "120",
    due: "210",
    paymentStatus: "Paid",
  },
  {
    id: "7",
    img: "assets/img/products/expire-product-01.png",
    date: "1/15/2022",
    supplier: "Apex Computers",
    reference: "PT007",
    status: "Pending",
    grandTotal: "1000",
    paid: "500",
    due: "1000",
    paymentStatus: "Overdue",
  },
  {
    id: "8",
    img: "assets/img/products/expire-product-02.png",
    date: "3/24/2022",
    supplier: "Best Power Tools",
    reference: "PT008",
    status: "Received",
    grandTotal: "210",
    paid: "120",
    due: "210",
    paymentStatus: "Paid",
  },
  {
    id: "9",
    img: "assets/img/products/expire-product-03.png",
    date: "3/24/2022",
    supplier: "Hatimi Hardware & Tools",
    reference: "PT009",
    status: "Pending",
    grandTotal: "5500",
    paid: "550",
    due: "5500",
    paymentStatus: "Unpaid",
  },
  {
    id: "10",
    img: "assets/img/products/expire-product-04.png",
    date: "3/24/2022",
    supplier: "Best Power Tools",
    reference: "PT0010",
    status: "Pending",
    grandTotal: "2580",
    paid: "1250",
    due: "2580",
    paymentStatus: "Unpaid",
  },
  {
    id: "11",
    img: "assets/img/products/stock-img-01.png",
    date: "3/24/2022",
    supplier: "Best Power Tools",
    reference: "PT0011",
    status: "Pending",
    grandTotal: "2580",
    paid: "1250",
    due: "2580",
    paymentStatus: "Unpaid",
  },
];
